var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlideezlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1373.83 789.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill-rule: evenodd;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2759.41,
    y1: -333.15,
    x2: 2306.41,
    y2: -333.15,
    gradientTransform: "translate(-2302 222.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#007eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00caff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3555.41,
    y1: -162.15,
    x2: 3669.41,
    y2: -162.15,
    gradientTransform: "translate(-2302 222.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7113dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9a4ef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d7b8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7b8f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3552.41,
    y1: -406.65,
    x2: 3671.41,
    y2: -406.65,
    gradientTransform: "translate(-2302 222.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#007eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00caff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3567.42,
    y1: -333.65,
    x2: 3193.41,
    y2: -333.65,
    gradientTransform: "translate(-2302 222.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#007eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00caff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3192.41,
    y1: -340.65,
    x2: 3078.41,
    y2: -340.65,
    gradientTransform: "translate(-2302 222.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#007eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00caff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3099.41,
    y1: -333.15,
    x2: 2746.41,
    y2: -333.15,
    gradientTransform: "translate(-2302 222.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#007eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00caff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.47,19.1v69.71c-5.26-1.79-9.32-2.69-12.19-2.69-5.5,0-10.21,2.03-14.16,6.09-3.94,4.06-5.91,8.96-5.91,14.69,0,4.9,2.15,11.11,6.45,18.64l5.56,9.68c10.04,17.44,15.05,34.29,15.05,50.53,0,23.78-8.45,43.9-25.36,60.39-16.91,16.49-37.54,24.73-61.91,24.73-11.71,0-23.3-2.69-34.76-8.06v-70.78c6.93,4.42,13.08,6.63,18.46,6.63,6.33,0,11.62-1.82,15.86-5.46,4.24-3.64,6.36-8.21,6.36-13.71,0-3.58-3.41-11.41-10.21-23.47-10.87-19.11-16.31-38.23-16.31-57.34,0-23.06,8.21-42.92,24.64-59.58,16.42-16.67,36.05-25,58.87-25,10.04,0,19.89,1.67,29.57,5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.39,20.18v244.61h-67.02V20.18h67.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.65,86.12v178.66h-67.02V86.12h67.02ZM325.32,6.38c9.08,0,16.93,3.2,23.56,9.59,6.63,6.39,9.95,13.95,9.95,22.67,0,9.32-3.14,16.97-9.41,22.94-6.27,5.98-14.31,8.96-24.1,8.96s-17.83-2.98-24.1-8.96c-6.27-5.97-9.41-13.62-9.41-22.94,0-8.72,3.32-16.28,9.95-22.67,6.63-6.39,14.48-9.59,23.57-9.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.1,20.18h67.02v148.91c0,27.36-7.17,49.64-21.5,66.84-8.24,9.92-18.73,17.8-31.45,23.65-12.72,5.85-25.78,8.78-39.16,8.78-26.64,0-49.1-8.96-67.38-26.88-18.28-17.92-27.42-39.9-27.42-65.95s9.08-47.01,27.24-65.41c18.16-18.4,39.66-27.6,64.51-27.6,3.94,0,9.92.36,17.92,1.08v73.83c-5.5-4.3-10.99-6.45-16.49-6.45-6.93,0-12.87,2.54-17.83,7.62-4.96,5.08-7.44,11.2-7.44,18.37s2.57,12.87,7.71,17.83c5.13,4.96,11.29,7.44,18.46,7.44,17.2,0,25.8-11.89,25.8-35.66V20.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M786.04,186.29h-101.61c-1.55-5.13-2.33-9.86-2.33-14.16,0-5.97,1.07-11.83,3.22-17.56h34.05c-2.39-13.26-9.86-19.89-22.4-19.89-8.36,0-15.17,3.56-20.43,10.66-5.26,7.11-7.88,16.22-7.88,27.33s2.54,20.97,7.62,28.13c5.08,7.17,11.74,10.75,19.98,10.75,6.69,0,13.14-3.34,19.35-10.04l38.17,45.88c-17.8,13.98-37.57,20.97-59.32,20.97-26.52,0-48.8-8.9-66.84-26.7-18.04-17.8-27.06-39.84-27.06-66.12s9.11-48.26,27.33-66.3c18.22-18.04,40.59-27.06,67.11-27.06s47.69,8.81,65.32,26.43c17.62,17.62,26.43,39.33,26.43,65.14,0,2.63-.24,6.81-.72,12.54Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4.41,558.52h113.28l.47,9.25c5.8,57.13,54.04,101.71,112.69,101.71,23.46,0,45.26-7.13,63.34-19.35l16.25-13.41,81.15,79.1-.54.59c-41,41.01-97.64,66.37-160.2,66.37-117.3,0-213.79-89.17-225.39-203.43l-1.05-20.83ZM152.14,504.32h40.28v40.28h-40.28v-40.28ZM19.22,485.04h40.28v40.28H19.22v-40.28ZM70.24,395.25h80.18v80.2h-80.18v-80.2ZM29,353.53h30.69v30.69h-30.69v-30.69ZM160.77,344.89h40.28v40.29h-40.28v-40.29ZM230.85,329.58c101.66,0,187.69,66.98,216.37,159.22l2.74,10.63,2.85,11.08c3.01,14.76,4.6,30.03,4.6,45.67s-1.59,30.92-4.6,45.67l-2.82,10.96h-208.37v-.1h-6.76c-1.83,0-3.31-1.48-3.31-3.31v-4.09h0v-94.47h0v-8.2c0-1.83,1.48-3.31,3.31-3.31h27.05l.23.1h66.22l-3.58-6.6c-20.35-30.13-54.83-49.95-93.93-49.95l-.74.04v-113.3l.74-.04ZM97.19,328.78h26.18v26.19h-26.18v-26.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1367.41,384.78c0,31.48-25.52,57-57,57s-57-25.52-57-57,25.52-57,57-57,57,25.52,57,57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1360.62,475.79h-101.43c-4.85,0-8.78,3.94-8.78,8.81v159.93c0,7.14,1.39,14.21,4.08,20.82l44.08,108.24s.03.08.05.12c2.08,5.39,7.08,9.07,12.85,9.07h49.16c4.85,0,8.78-3.95,8.78-8.81v-289.37c0-4.87-3.93-8.82-8.79-8.82h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1078.43,562.4l-2.28,5.59-.08.1-19.28,47.28h43.24l-21.6-52.97ZM1072.76,332.76c2.44-4.29,9.82-3.64,11.33,0l94.71,232.22.07.56,86.23,211.46c1.12,2.76-.91,5.78-3.88,5.78h-90.12c-1.7,0-3.24-1.03-3.88-2.6l-42.01-103.02h-93.6l-42.01,103.02c-.64,1.57-2.18,2.6-3.88,2.6h-90.12c-2.97,0-5-3.02-3.88-5.78l93.56-229.44h0,0s0,0,0,0h-.01l.08-.1,33.64-82.49h-.15l53.92-132.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M777.91,540.78h111c.83,0,1.5.79,1.5,1.77v41.46c0,.98-.67,1.77-1.5,1.77h-111c-.83,0-1.5-.79-1.5-1.77v-41.46c0-.98.67-1.77,1.5-1.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M470.31,329.03h283.92l40.45-.25c4.07,2.69,2.36,6.46,2.44,7.33l-5.51,10.78-13.21,25.82-152.13,297.52h144.72c2.09,0,3.79,1.99,3.79,4.46v104.51c0,1.23-.42,2.34-1.11,3.15l-.88.43h-325.43l-1.1-.56c-2.2-1.12-2.48-4.98-.62-8.62l5.51-10.78,13.21-25.82,150.92-295.14h-143.73c-2.1,0-3.8-2-3.8-4.46v-104.51c0-1.23.42-2.35,1.11-3.16l1.45-.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideezlogo);
export default __webpack_public_path__ + "static/media/slideezlogo.d8d1e0914f0860e6f6adf98b09e1b210.svg";
export { ForwardRef as ReactComponent };